// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"checkBoxField_checkboxWrapper__3vPjc","checkedImg":"checkBoxField_checkedImg__OX3nT","testL":"checkBoxField_testL__oIEa-"};